module.exports = __webpack_public_path__ + "img/eyetracking-gif.83aa7e2e.gif";